import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-self-enroll',
  templateUrl: './self-enroll.component.html',
  styleUrls: ['./self-enroll.component.css']
})
export class SelfEnrollComponent implements OnInit {
  constructor(private router: Router, private modalService: NgbModal) { }
  closeResult: string;

  ngOnInit() { }

  open(content) {
    this.modalService.open(content, { size: 'lg' });
  }

  start() {
    this.router.navigate(['/selfEnroll/e-sign']);
  }
}
